import { AritoIcon } from '@/components/custom/arito/icon';
import { NavMenu } from '../types';

export const giaThanhMenu: NavMenu = {
  title: 'Giá thành',
  items: [
    {
      title: 'Lệnh sản xuất',
      icon: <AritoIcon icon={454} />,
      href: '/gia-thanh/lenh-san-xuat'
    },
    {
      title: 'Định mức nguyên vật liệu',
      icon: <AritoIcon icon={650} />,
      href: '/gia-thanh/dinh-muc-nguyen-vat-lieu'
    },
    {
      title: 'Tính giá thành',
      items: [
        {
          title: 'Tính giá thành',
          icon: <AritoIcon icon={167} />,
          href: '/gia-thanh/tinh-gia-thanh/tinh-gia-thanh'
        },
        {
          title: 'Bút toán phân bổ chi phí sản xuất chung',
          href: '/gia-thanh/tinh-gia-thanh/but-toan-phan-bo-chi-phi-san-xuat-chung'
        }
      ]
    },
    {
      title: 'Cập nhật dở dang',
      items: [
        {
          title: 'Cập nhật giá trị dở dang đầu kỳ theo yếu tố chi phí',
          icon: <AritoIcon icon={39} />,
          href: '/gia-thanh/cap-nhat-do-dang/cap-nhat-gia-tri-do-dang-dau-ky-theo-yeu-to-chi-phi'
        },
        {
          title: 'Cập nhật vật tư dở dang đầu kỳ',
          href: '/gia-thanh/cap-nhat-do-dang/cap-nhat-vat-tu-do-dang-dau-ky'
        },
        {
          title: 'Cập nhật kiểm kê vật tư cuối kỳ',
          icon: <AritoIcon icon={39} />,
          href: '/gia-thanh/cap-nhat-do-dang/cap-nhat-kiem-ke-vat-tu-cuoi-ky'
        },
        {
          title: 'Cập nhật số lượng sản phẩm dở dang cuối kỳ',
          href: '/gia-thanh/cap-nhat-do-dang/cap-nhat-so-luong-san-pham-do-dang-cuoi-ky'
        }
      ]
    },
    {
      title: 'Danh mục',
      icon: <AritoIcon icon={41} />,
      group: 1,
      items: [
        {
          title: 'Danh mục yếu tố',
          icon: <AritoIcon icon={39} />,
          href: '/gia-thanh/danh-muc/danh-muc-yeu-to'
        },
        {
          title: 'Danh mục loại yếu tố',
          href: '/gia-thanh/danh-muc/danh-muc-loai-yeu-to'
        },
        {
          title: 'Danh mục nhóm yếu tố',
          icon: <AritoIcon icon={73} />,
          href: '/gia-thanh/danh-muc/danh-muc-nhom-yeu-to'
        },
        {
          title: 'Danh mục công đoạn',
          href: '/gia-thanh/danh-muc/danh-muc-cong-doan'
        }
      ]
    },
    {
      title: 'Khai báo',
      icon: <AritoIcon icon={550} />,
      group: 1,
      items: [
        {
          title: 'Khai báo hệ số phân bổ',
          icon: <AritoIcon icon={626} />,
          href: '/gia-thanh/khai-bao/khai-bao-he-so-phan-bo'
        },
        {
          title: 'Khai báo vật tư thay thế',
          href: '/gia-thanh/khai-bao/khai-bao-vat-tu-thay-the'
        },
        {
          title: 'Khai báo đối tượng nhận phân bổ chi phí',
          href: '/gia-thanh/khai-bao/khai-bao-doi-tuong-nhan-phan-bo-chi-phi'
        }
      ]
    },
    {
      title: 'Báo cáo',
      icon: <AritoIcon icon={230} />,
      group: 1,
      items: [
        {
          title: 'Thẻ giá thành cho sản phẩm',
          href: '/gia-thanh/bao-cao/the-gia-thanh-cho-san-pham',
          icon: <AritoIcon icon={279} />,
          group: 0
        },
        {
          title: 'Báo cáo giá thành sản phẩm theo nhóm yếu tố',
          href: '/gia-thanh/bao-cao/bao-cao-gia-thanh-san-pham-theo-nhom-yeu-to',
          group: 0
        },
        {
          title: 'Báo cáo giá thành chi tiết theo vật tư',
          icon: <AritoIcon icon={126} />,
          href: '/gia-thanh/bao-cao/bao-cao-gia-thanh-chi-tiet-theo-vat-tu',
          group: 1
        },
        {
          title: 'Báo cáo tổng hợp chi phí sản xuất theo sản phẩm',
          href: '/gia-thanh/bao-cao/bao-cao-tong-hop-chi-phi-san-xuat-theo-san-pham',
          group: 1
        },
        {
          title: 'Báo cáo so sánh NVL thực tế so với định mức',
          href: '/gia-thanh/bao-cao/bao-cao-so-sanh-nvl-thuc-te-va-dinh-muc-theo-san-pham',
          group: 1
        },
        {
          title: 'Bảng định mức nguyên vật liệu',
          href: '/gia-thanh/bao-cao/bang-dinh-muc-nguyen-vat-lieu',
          group: 1
        }
      ]
    },
    {
      title: 'Kiểm tra giá thành',
      icon: <AritoIcon icon={231} />,
      group: 1,
      items: [
        {
          title: 'Vật tư xuất sản xuất nhưng chưa khai báo định mức',
          href: '/gia-thanh/kiem-tra-gia-thanh/vat-tu-xuat-san-xuat-nhung-chua-khai-bao-dinh-muc'
        },
        {
          title: 'Vật tư có khai báo định mức nhưng chưa sản xuất',
          href: '/gia-thanh/kiem-tra-gia-thanh/vat-tu-co-khai-bao-dinh-muc-nhung-chua-san-xuat'
        }
      ]
    }
  ]
};
